var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSegments = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.471 10.504h3.154v3.971h-3.971v-2.413L7.5 8.718l-3.154 3.344v2.413H.375v-3.971h3.154L6.721 7.35V4.823a2.4 2.4 0 0 1-1.15-.845A2.24 2.24 0 0 1 5.126 2.6q0-.627.323-1.178a2.4 2.4 0 0 1 .874-.874A2.3 2.3 0 0 1 7.5.225q.627 0 1.178.323t.874.874q.323.55.323 1.178 0 .779-.447 1.378a2.4 2.4 0 0 1-1.149.845V7.35z"
})));
export default SvgSegments;